import { render, staticRenderFns } from "./EmdUserMenu.vue?vue&type=template&id=865f1d66&"
import script from "./EmdUserMenu.vue?vue&type=script&lang=js&"
export * from "./EmdUserMenu.vue?vue&type=script&lang=js&"
import style0 from "./EmdUserMenu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./EmdUserMenu.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/data/vstsagent03/user/3333/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('865f1d66')) {
      api.createRecord('865f1d66', component.options)
    } else {
      api.reload('865f1d66', component.options)
    }
    module.hot.accept("./EmdUserMenu.vue?vue&type=template&id=865f1d66&", function () {
      api.rerender('865f1d66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/emerald/organisms/EmdUserMenu.vue"
export default component.exports